import type { PropsWithChildren, ReactNode } from "react";

interface EditorialShellProps extends PropsWithChildren {
  footer?: ReactNode;
  hideFooter?: boolean;
  className?: string;
}

export function EditorialShell({ children, footer, hideFooter = false, className = "" }: EditorialShellProps) {
  return (
    <div className={`app-frame ${className}`.trim()}>
      <div className="paper-noise" aria-hidden="true" />
      <header className="catalog-header">
        <a className="shell-brand" href="#/" aria-label="返回 WMLSTI 首页">
          <strong>WMLSTI</strong>
          <span>五月天人生观测试</span>
        </a>
      </header>
      <main id="main-content" className="page-content">
        {children}
      </main>
      {!hideFooter && (
        <footer className="page-footer">
          <span>{footer ?? "WMLS 人格测试"}</span>
          <span>相信 · 眷恋 · 倔强 · 远方 · 孤独 · 狂欢</span>
        </footer>
      )}
    </div>
  );
}
